
export const pickingCancel = {
    searchText: '',
    addText: '',
    checkbox: false,
    expandable: false,
    filter: false,
    filterDefault: '',
    disabled: false,
    partialField: '',
    export: true,
    exportAllData: true,
    exportFile: 'pedidos_cancelados.xlsx',
    showIcon: './assets/icon/ico_placeholder_documentos.svg',
    paginator: true,
    columns: [
        {
            title: 'N° Despacho',
            name: 'serialNumber',
            type: 'string',
            checkAll: false,
            editable: false,
            class: 'center w130',
            value: (element: any) => element.serialNumber
        },
        {
            title: 'SKU/descripción',
            name: 'skuFullName',
            type: 'string',
            editable: false,
            checkAll: false,
            align: 'center',
            value: (element: any) => element.skuFullName
        },
        {
            title: 'Cant.',
            name: 'amount',
            type: 'string',
            editable: false,
            checkAll: false,
            class: 'center',
            value: (element: any) => element.amount
        },
        {
            title: 'stock',
            name: 'amountStock',
            type: 'string',
            editable: false,
            checkAll: false,
            class: 'center',
            value: (element: any) => element.amountStock
        },
        {
            title: 'Fecha',
            name: 'rejectedDate',
            type: 'string',
            editable: false,
            checkAll: false,
            class: 'center',
            value: (element: any) => element.rejectedDate
        },
        {
            title: 'Motivo de rechazo',
            name: 'reasonDescription',
            type: 'string',
            editable: false,
            checkAll: false,
            align: 'center',
            value: (element: any) => element.reasonDescription
        },
        {
            title: 'Pickeador',
            name: 'pickerFullName',
            type: 'string',
            editable: false,
            checkAll: false,
            align: 'center',
            value: (element: any) => element.pickerFullName
        },
        {
            title: 'División',
            name: 'division',
            type: 'string',
            editable: false,
            checkAll: false,
            align: 'center',
            value: (element: any) => element.division
        },
        {
            title: 'Área',
            name: 'area',
            type: 'string',
            editable: false,
            checkAll: false,
            align: 'center',
            value: (element: any) => element.area
        },
        {
            title: 'Departamento',
            name: 'department',
            type: 'string',
            editable: false,
            checkAll: false,
            align: 'center',
            value: (element: any) => element.department
        },
        {
            title: 'Fecha de creación',
            name: 'dateCreated',
            type: 'string',
            editable: false,
            checkAll: false,
            align: 'center',
            value: (element: any) => element.dateCreated
        },
        {
            title: 'Fecha de cancelación',
            name: 'dateCanceled',
            type: 'string',
            editable: false,
            checkAll: false,
            align: 'center',
            value: (element: any) => element.dateCanceled
        }
    ]
};
